"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.iggMessages = exports.Igg = void 0;
const schema_1 = require("../../../../schema");
var Igg;
(function (Igg) {
    Igg["POSITIVE"] = "POSITIVE";
    Igg["NEGATIVE"] = "NEGATIVE";
    Igg["IN_PROGRESS"] = "IN_PROGRESS";
})(Igg || (exports.Igg = Igg = {}));
exports.iggMessages = {
    [Igg.POSITIVE]: {
        id: "ltx.phaseI.viralSerology.varicellaSerology.igg.POSITIVE",
        defaultMessage: "Pozitív"
    },
    [Igg.NEGATIVE]: {
        id: "ltx.phaseI.viralSerology.varicellaSerology.igg.NEGATIVE",
        defaultMessage: "Negatív"
    },
    [Igg.IN_PROGRESS]: {
        id: "ltx.phaseI.viralSerology.varicellaSerology.igg.IN_PROGRESS",
        defaultMessage: "Folyamatban"
    }
};
const igg = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(Igg.POSITIVE),
    schema_1.Schema.singleChoiceItem(Igg.NEGATIVE),
    schema_1.Schema.singleChoiceItem(Igg.IN_PROGRESS)
])
    .interpretation({ vocab: "ltx", code: "varicella_serology_igg" })
    .tag({ vocab: "snomed", code: "313587003" })
    .tag({ vocab: "loinc", code: "19162-7" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ igg })
    .interpretation({ vocab: "ltx", code: "varicella_serology" })
    .tag({ vocab: "snomed", code: "104326007" })
    .tag({ vocab: "snomed", code: "20135006" })
    .tag({ vocab: "snomed", code: "165994006" });
